import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import GrowthScoutComp from './GrowthScoutComp';

function GrowthScout() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <GrowthScoutComp />
      </div>
    </div>
  );
}

export default GrowthScout;
